exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!vuetify/dist/vuetify.min.css"), "");

// module
exports.push([module.id, "\n.vuetify-container[data-v-e69093c8] {\n}\nlabel.v-label[data-v-e69093c8] {\n    font-weight: 300 !important;\n    margin-bottom: 0;\n}\n.v-snack__content[data-v-e69093c8] {\n    justify-content: left !important;\n}\n.align-items-center[data-v-e69093c8] {\n    align-items: center;\n    display: inline-flex;\n}\n.content-header[data-v-e69093c8]{\n    margin:-15px -15px 15px -15px;\n}\n\n", ""]);

// exports
